import type { BillingCycle, PlanCode, PrototypeRuntime } from "../prototypeTypes";

export async function callBillingProvider(
	runtime: PrototypeRuntime,
	currentPlan: PlanCode,
	nextPlan: Exclude<PlanCode, "visitor" | "free">,
	currentSubscriptionId?: string,
	targetBillingCycle: BillingCycle = runtime.billingCycle,
) {
	if (currentPlan === "visitor" || currentPlan === "free") {
		// P0-1: checkout 返回 checkoutUrl, 跳转 Creem 支付页
		const result = await runtime.api.createCheckout({
			plan: nextPlan,
			billingCycle: targetBillingCycle,
		});
		if (result?.checkoutUrl) {
			window.location.assign(result.checkoutUrl);
		}
		return;
	}
	const subscriptionId = currentSubscriptionId?.trim();
	if (!subscriptionId || subscriptionId === 'prototype-subscription') throw new Error('billing_subscription_not_loaded');
	return runtime.api.upgradeSubscription({
		subscriptionId,
		toPlan: nextPlan,
		billingCycle: targetBillingCycle,
	});
}
